import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isProjectEditionRequestFailure({ uuid }) {
      const state = getState().find((req) => req.project.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isProjectEditionRequestPending({ uuid }) {
      const state = getState().find((req) => req.project.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isProjectEditionRequestSuccess({ uuid }) {
      const state = getState().find((req) => req.project.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
